import React, { useState } from "react";
import ReactDOM from "react-dom";
import Modal from "react-modal";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement("#root");

export default function ModalProduct({
  closeModal = () => {},
  product = {},
  saveProduct = () => {},
  deleteProduct = () => {},
}) {
  const [data, setData] = useState(product);

  const handleChangeData = (e) => {
    const value = e.target.value;
    const name = e.target.name;

    setData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Modal
      isOpen={true}
      style={customStyles}
      onRequestClose={closeModal}
      contentLabel="Example Modal"
    >
      <div className="modal-close" onClick={closeModal}>
        X
      </div>
      <div className="modal-container-inputs">
        <p className="modal-label">Codigo</p>
        <input
          value={data._id}
          name="_id"
          onChange={handleChangeData}
          className="modal-input"
        />
        <p className="modal-label">Nombre</p>
        <input
          value={data.name}
          name="name"
          onChange={handleChangeData}
          className="modal-input"
        />
        <p className="modal-label">Precio</p>
        <input
          value={data.price}
          name="price"
          onChange={handleChangeData}
          className="modal-input"
        />
      </div>
      <div className="modal-container-buttons">
        <button
          className="button"
          onClick={() => saveProduct(data, product._id)}
        >
          Guardar
        </button>
        {product._id && (
          <button className="button button-delete" onClick={() => deleteProduct(product._id)}>
            Eliminar
          </button>
        )}
      </div>
    </Modal>
  );
}

ReactDOM.render(<ModalProduct />, document.getElementById("root"));
